"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CNTableColumnGroup = function (_React$Component) {
    (0, _inherits3.default)(CNTableColumnGroup, _React$Component);

    function CNTableColumnGroup(props) {
        (0, _classCallCheck3.default)(this, CNTableColumnGroup);
        return (0, _possibleConstructorReturn3.default)(this, (CNTableColumnGroup.__proto__ || (0, _getPrototypeOf2.default)(CNTableColumnGroup)).call(this, props));
    }

    (0, _createClass3.default)(CNTableColumnGroup, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);
    return CNTableColumnGroup;
}(_react2.default.Component);

CNTableColumnGroup.propTypes = {
    title: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node])
};
exports.default = CNTableColumnGroup;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/ColumnGroup.js
// module id = 279
// module chunks = 0